import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // //add visit

  //addBanner
  addBannerData,
  addBannerSuccess,
  addBannerFailed,
  //updateBanner
  updateBannerData,
  updateBannerDataSuccess,
  updateBannerDataFailed,
  //getBanner
  getBannerData,
  getBannerDataSuccess,
  getBannerDataFailed,
  //deleteBanner
  deleteBannersData,
  deleteBannerSuccess,
  deleteBannerFailed,

  //getCity
  getDistrictApiData,
  getDistrictDataSuccess,
  getDistrictDataFailed,

  // add City
  addDistrictApiData,
  addDistrictApiSuccess,
  addDistrictApiFailed,

  // update city
  updateDistrictApiData,
  updateDistrictApiSuccess,
  updateDistrictApiFailed,
  // delete City
  deleteDistrictApiData,
  deleteDistrictApiSuccess,
  deleteDistrictApiFailed,

  //add State
  addStateData,
  addStateDataFailed,
  addStateDataSuccess,
  //update State
  updateStateData,
  updateStateDataFailed,
  updateStateDataSuccess,
  //delete State
  deleteStateData,
  deleteStateDataFailed,
  deleteStateDataSuccess,
  //get State
  getStateData,
  getStateDataFailed,
  getStateDataSuccess,
  // Taluk List
  talukListApiCall,
  talukListApiSuccess,
  talukListApiFailed,

  // Add Taluk
  addTalukApiCall,
  addTalukApiSuccess,
  addTalukApiFailed,

  // Update Taluk
  updateTalukApiCall,
  updateTalukApiSuccess,
  updateTalukApiFailed,

  // delete Taluk
  deleteTalukApiCall,
  deleteTalukApiSuccess,
  deleteTalukApiFailed,
  // Taluk Details
  talukDetailsApiCall,
  talukDetailsSuccess,
  talukDetailsFailed,

  //uploadImage
  uploadImage,
  uploadImageSuccess,
  uploadImageFailed,
} from './slice'
import { API } from '../../services'

//Banner
function* addBanner({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addBanner, payload)
    if (response.data && response.status === 200) {
      yield put(addBannerSuccess({ payload: response?.data }))
    } else {
      yield put(addBannerFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addBannerFailed({ message: error?.message }))
  }
}

function* updateBanner({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateBanner, payload)
    if (response.data && response.status === 200) {
      yield put(updateBannerDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateBannerDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateBannerDataFailed({ message: error?.message }))
  }
}

function* getBanner() {
  try {
    const response = yield call(API.settingApi.getBanner)
    if (response.data && response.status === 200) {
      yield put(getBannerDataSuccess({ payload: response?.data }))
    } else {
      yield put(getBannerDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getBannerDataFailed({ message: error?.message }))
  }
}

function* deleteBanner({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteBanner, payload)
    if (response.data && response.status === 200) {
      yield put(deleteBannerSuccess({ payload: response?.data }))
    } else {
      yield put(deleteBannerFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteBannerFailed({ message: error?.message }))
  }
}

//States
function* addState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addState, payload)
    if (response.data && response.status === 200) {
      yield put(addStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(addStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStateDataFailed({ message: error?.message }))
  }
}

function* updateState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateState, payload)
    if (response.data && response.status === 200) {
      yield put(updateStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStateDataFailed({ message: error?.message }))
  }
}

function* getState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.stateList, payload)
    if (response.data && response.status === 200) {
      yield put(getStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(getStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStateDataFailed({ message: error?.message }))
  }
}

function* deleteState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteState, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStateDataFailed({ message: error?.message }))
  }
}
//City
function* getDistrictApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.districtListApi, payload)

    if (response.data && response.status === 200) {
      yield put(getDistrictDataSuccess({ payload: response?.data }))
    } else {
      yield put(getDistrictDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getDistrictDataFailed({ message: error?.message }))
  }
}
function* addDistrictApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addDistrict, payload)

    if (response.data && response.status === 200) {
      yield put(addDistrictApiSuccess({ payload: response?.data }))
    } else {
      yield put(addDistrictApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addDistrictApiFailed({ message: error?.message }))
  }
}
function* updateDistrictApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateDistrict, payload)

    if (response.data && response.status === 200) {
      yield put(updateDistrictApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateDistrictApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateDistrictApiFailed({ message: error?.message }))
  }
}
function* deleteDistrictApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteDistrict, payload)

    if (response.data && response.status === 200) {
      yield put(deleteDistrictApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteDistrictApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteDistrictApiFailed({ message: error?.message }))
  }
}

function* talukListApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.talukListApi, payload)

    if (response.data && response.status === 200) {
      yield put(talukListApiSuccess({ payload: response?.data }))
    } else {
      yield put(talukListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(talukListApiFailed({ message: error?.message }))
  }
}
function* addTalukApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addTaluk, payload)

    if (response.data && response.status === 200) {
      yield put(addTalukApiSuccess({ payload: response?.data }))
    } else {
      yield put(addTalukApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addTalukApiFailed({ message: error?.message }))
  }
}
function* updateTalukApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateTaluk, payload)

    if (response.data && response.status === 200) {
      yield put(updateTalukApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateTalukApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateTalukApiFailed({ message: error?.message }))
  }
}
function* deleteTalukApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteTaluk, payload)

    if (response.data && response.status === 200) {
      yield put(deleteTalukApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteTalukApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteTalukApiFailed({ message: error?.message }))
  }
}
function* talukDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.talukDetails, payload)

    if (response.data && response.status === 200) {
      yield put(talukDetailsSuccess({ payload: response?.data }))
    } else {
      yield put(talukDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(talukDetailsFailed({ message: error?.message }))
  }
}

//Upload Image
function* postImage({ type, payload }) {
  try {
    const response = yield call(API.commonApi.postImage, payload)

    if (response.data && response.status === 200) {
      yield put(uploadImageSuccess({ payload: response?.data }))
    } else {
      yield put(uploadImageFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(uploadImageFailed({ message: error?.message }))
  }
}

function* settingSaga() {
  yield takeEvery(updateBannerData, updateBanner)
  yield takeEvery(addBannerData, addBanner)
  yield takeEvery(getBannerData, getBanner)
  yield takeEvery(deleteBannersData, deleteBanner)

  //city
  yield takeEvery(getDistrictApiData, getDistrictApi)
  yield takeEvery(addDistrictApiData, addDistrictApi)
  yield takeEvery(deleteDistrictApiData, deleteDistrictApi)
  yield takeEvery(updateDistrictApiData, updateDistrictApi)

  yield takeEvery(updateStateData, updateState)
  yield takeEvery(addStateData, addState)
  yield takeEvery(getStateData, getState)
  yield takeEvery(deleteStateData, deleteState)

  yield takeEvery(uploadImage, postImage)

  // Taluk
  yield takeEvery(talukListApiCall, talukListApi)
  yield takeEvery(addTalukApiCall, addTalukApi)
  yield takeEvery(updateTalukApiCall, updateTalukApi)
  yield takeEvery(deleteTalukApiCall, deleteTalukApi)
  yield takeEvery(talukDetailsApiCall, talukDetailsApi)
}

export default settingSaga
